<template>
  <div v-click-outside="hideDropdown"
       class="d-block d-md-inline-block position-relative filter-item"
       :class="{ 'filter-item__active' : show }"
  >
    <b-button class="dropdown-toggle text-left"
              variant="outline-light"
              :disabled="disabled"
              :class="{ 'active': show }"
              :style="'min-width: ' + filterWidth + 'px'"
              @click="toggleDropdown"
    >
      <slot name="title">{{ title }}</slot>
    </b-button>
    <div ref="filterOptions"
         class="filter-item__options list-unstyled"
         data-test-id="filter-item__options"
         :class="{ 'w-100' : shouldStretch, 'invisible' : !show }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: false,
      default() { return [] }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      show: true,
      filterWidth: 'auto',
      shouldStretch: false,
      internalOptions: []
    }
  },
  watch: {
    show(_v) {
      if (_v && this.options) {
        this.internalOptions = this.options.map(x => x.value)
        this.$emit('show')
      } else if (this.internalOptions.length && this.options.length) {
        // compare changes
        if (this.options.filter((x, i) => this.internalOptions[i] !== x.value).length) this.$emit('updated')
        this.$emit('hide')
      } else {
        this.$emit('hide')
      }
    },
    labels: {
      deep: true,
      handler: function () { this.recalculateWidth() }
    }
  },
  mounted() {
    this.recalculateWidth()
    this.show = false
  },
  methods: {
    hideDropdown() {
      this.show = false
    },
    showDropdown() {
      this.show = true
    },
    toggleDropdown() {
      if (!this.disabled) this.show = !this.show
    },
    recalculateWidth() {
      this.$nextTick(() => {
        this.filterWidth = this.$refs.filterOptions.clientWidth + 2
        this.shouldStretch = this.filterWidth < this.$el.clientWidth
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/grid';
@import '../../../scss/colors';
@import '../../../scss/z-index';

.filter-item {
  margin: .25rem 0;

  @include media-breakpoint-up('md') {
    margin: .5rem .5rem 0 0;
  }

  &__active {
    z-index: 1;
  }

  &__options {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 2.2rem;
    box-shadow: 0 .15rem .5rem rgba($black, .35);
    max-height: 400px;
    overflow: auto;

    &> div,
    &> li {
      background-color: $white !important;
    }

    @include media-breakpoint-down('sm') {
      right: 0;
    }
  }

  &.wide {
    width: 100%;
    .filter-item__options {
      right: 0;
    }
    button {
      width: 100%;
    }
  }

  button.dropdown-toggle {
    padding-right: 1.675rem;
    background: $gray-100;
    border-color: $gray-400;
    color: $gray-800;

    @include media-breakpoint-down('sm') {
      width: 100%;
    }

    &:after {
      position: absolute;
      top: calc(50% - .255rem);
      right: .75rem;
      transition: .2s all;
    }

    &.active {
      z-index: 1;

      &:active,
      &:focus,
      & {
        box-shadow: none !important;
        outline: none;
        border-color: transparent;
        border-bottom-color: $gray-200;
        background: transparent !important;
      }

      &:after {
        transform: rotate(180deg);
      }
    }
  }

  &.is-invalid {
    button {
      border-color: $danger;
    }
  }

  &.dropdown {
    &.is-placeholder {
      button.dropdown-toggle {
        color: $gray-700;
      }
    }

    button.dropdown-toggle {
      color: $gray-900;
      background: $white;
      font-family: "Helvetica Neue", Helvetica, Roboto, sans-serif;
      white-space: normal;
      line-height: 16px;
    }
  }

  & .dropdown {
    &-item {
      white-space: normal;
    }
  }
}
</style>
